import React from "react";
import SocialIcons from "./socialIcons";
import KdMenuImg from "@/app/assets/KD-Logo_white.png";
import Image from "next/image";
import Arrow from "../../../public/office-arrow.svg";
import GoogleCaptchaWrapper from "../googleCaptchaWrapper";
import HomepageForm from "../forms/homepageForm";

type OverlayMode = "menu" | "contact";

export default function DropDownMenu({
    isOpen,
    mode,
    icons,
    links,
    contact,
    homepageFormData,
    showHomepageForm = true,
}: {
    isOpen: boolean;
    mode: OverlayMode;
    icons?: any;
    links?: any;
    contact?: string;
    homepageFormData?: any;
    showHomepageForm?: boolean;
}) {
    let rightContentText = ["Start a", "New Project", "With Us"];

    return (
        <>
            <div
                className={`fixed top-0 left-0 right-0 bottom-0 h-[100dvh] min-h-[100dvh] md:min-h-[100lvh] w-[100lvw] ${
                    mode === "contact"
                        ? "bg-transparent p-0 block"
                        : "bg-black flex flex-col md:flex-row md:items-center px-6 lg:px-[10.2vw] lg:pb-[7.292vw] lg:pt-0 pt-14 pb-4 gap-4 xs:gap-5 md:gap-10 smallMobile:gap-2"
                } z-50 burgerMenu duration-500
                    ${isOpen ? "active" : ""} 
                    ${mode === "contact" ? "overflow-y-auto md:overflow-hidden bg-[radial-gradient(circle_at_62%_56%,#8a2df2_0%,#621bc6_34%,#32116f_70%,#1a0a43_100%)] border border-[#9150ff]" : "overflow-y-auto md:overflow-y-visible bg-[linear-gradient(135deg,_#37ded7_0%,_#37ded7_20%,_#851bed_80%,_#851bed_100%)]"} scroll-smooth`}
            >
                {mode === "contact" && showHomepageForm ? (
                    <div className="relative w-full min-h-[100lvh] md:h-[100lvh] overflow-y-auto md:overflow-hidden ">
                        <div className="h-full w-full max-w-[1220px] mx-auto px-6 md:px-10 pt-20 md:pt-16 pb-8 flex flex-col">
                            <div className="text-center mb-6 md:mb-7 shrink-0">
                                <h2 className="text-stroke text-transparent uppercase font-bold text-[54px] md:text-font-100 leading-[1]">
                                    Get In Touch
                                </h2>
                                <p className="text-white/90 text-base md:text-font-32 mt-4">
                                    Bring your brand to life, Made Differently.
                                    Share your brief with us here
                                </p>
                            </div>

                            <div className="shrink-0">
                                <GoogleCaptchaWrapper>
                                    <HomepageForm
                                        formData={
                                            homepageFormData
                                                ? {
                                                      ...homepageFormData,
                                                      heading: "",
                                                  }
                                                : homepageFormData
                                        }
                                        inOverlay
                                    />
                                </GoogleCaptchaWrapper>
                            </div>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="flex flex-col sm:flex-row flex-[1_1_auto] gap-y-4 sm:gap-y-[7.292vw] justify-end sm:justify-center">
                            <a href="/" aria-label="Kingdom Digital home">
                                <Image
                                    src={KdMenuImg}
                                    alt={"mobile menu web logo"}
                                    className=" sm:hidden mx-auto my-0 w-44 xs:w-52"
                                />
                            </a>
                            <div className="relative flex flex-col flex-wrap h-fit md:w-full justify-center items-center md:items-start text-center md:text-left gap-y-1 xs:gap-y-2 mb-4 sm:mb-0 sm:gap-y-0">
                                {links.leftMenu.links.map(
                                    (link: any, index: number) => (
                                        <a
                                            key={index}
                                            href={link.href}
                                            className={`text-[clamp(2rem,8.6vw,2.5rem)] sm:text-font-100 !leading-[0.95] uppercase w-fit !font-bold hover:text-white duration-300 text-stroke text-transparent lg:flex-none`}
                                        >
                                            {link.label}
                                        </a>
                                    ),
                                )}
                                {/* Border Decor */}
                                <div className="absolute right-0 md:top-0 md:bottom-0 -bottom-12 m-auto h-[1px] md:h-full w-full md:w-[1px] bg-white hidden md:block "></div>
                            </div>
                        </div>

                        <div className="relative flex flex-col justify-center pt-2 flex-[0_1_auto] h-fit w-full md:p-[5.2vw] pr-0 md:pr-[0] md:mb-[3vw] ">
                            {/* Border Decor */}
                            <div className="absolute left-0 right-0 -top-2 xs:-top-3 smallMobile:top-0 m-auto h-[1px] w-[75%] bg-white md:hidden block "></div>
                            <a
                                href={links.rightMenu.links[0].href}
                                className="flex flex-col lg:mb-0 group items-center md:items-start text-center md:text-left"
                                // className="flex flex-col lg:mb-[10.25vw] group items-center sm:items-start text-center sm:text-left"
                            >
                                {[...Array(rightContentText.length)].map(
                                    (_, i) => {
                                        if (i != 1) {
                                            return (
                                                <span
                                                    className="relative text-[clamp(2rem,8.8vw,2.5rem)] sm:text-font-100 font-bold !leading-[0.95] text-stroke text-transparent uppercase group-hover:text-white transition-colors duration-150"
                                                    key={i}
                                                >
                                                    {rightContentText[i]}
                                                    {rightContentText.length -
                                                        1 ==
                                                        i && (
                                                        <Image
                                                            src={Arrow}
                                                            alt={""}
                                                            width={100}
                                                            height={100}
                                                            className=" aspect-square absolute h-[50%] w-auto right-0 bottom-0 m-auto translate-x-[150%]"
                                                        />
                                                    )}
                                                </span>
                                            );
                                        } else {
                                            return (
                                                <span
                                                    className="relative text-[clamp(2rem,8.8vw,2.5rem)] sm:text-font-100 leading-[0.95] font-bold uppercase text-turquoise text-stroke-turquoise duration-150"
                                                    key={i}
                                                >
                                                    {rightContentText[i]}
                                                </span>
                                            );
                                        }
                                    },
                                )}
                            </a>
                        </div>

                    </>
                )}

                <div className="absolute hidden md:flex gap-4 bottom-4 left-[30px] lg:left-[10.2vw] z-10">
                    {contact && (
                        <a
                            href={`tel:${contact
                                .replace("+", "")
                                .replaceAll(" ", "")}`}
                            className="phone-num w-max text-font-24 font-medium tracking-wide text-white"
                        >
                            {contact}
                        </a>
                    )}
                    <SocialIcons data={icons} />
                </div>

                <div className="relative flex flex-col md:hidden mt-auto gap-y-1 sm:justify-start sm:items-start sm:text-left justify-center items-center text-center pt-2 z-10">
                    {contact && (
                        <a
                            href={`tel:${contact
                                .replace("+", "")
                                .replaceAll(" ", "")}`}
                            className="phone-num w-max text-xl font-medium tracking-wide text-white"
                        >
                            {contact}
                        </a>
                    )}
                    <SocialIcons data={icons} />
                </div>

                <Image
                    src={KdMenuImg}
                    width={510}
                    height={200}
                    alt="kd-menu-image"
                    className="absolute bottom-9 sm:bottom-4 right-4 w-[26.563vw] object-contain min-w-52 opacity-0 sm:opacity-100 pointer-events-none"
                />
            </div>
        </>
    );
}
